import { addEditData, getData } from '../generic';

import { cAPI } from '../../../utils/cAPI';

export const getOpinions = () => dispatch => getData(dispatch, cAPI.APGetProductReviews, null, 'opinions');
export const editOpinions = formData => dispatch => addEditData(dispatch, cAPI.APUpdateProductReview, formData, 'opinions');
